import { useMemo } from 'react'
import { useGetAllCustomersQuery } from '../redux/api/customerApi'
import { ContactKind, CustomerState, ManagerKind, ManagerModel } from '@ail/customers-api'

export function useManagers() {
  const allCustomers = useGetAllCustomersQuery()

  const managers = useMemo(() => {
    const customerStates = [
      CustomerState.ActiveFleet,
      CustomerState.BlockPayments,
      CustomerState.BrokerProspect,
      CustomerState.New,
      CustomerState.OnHold,
    ]
    const managerKinds = [ManagerKind.OfficeSales]
    const managerMap: Partial<Record<string, ManagerModel>> = {}
    for (const c of allCustomers.currentData ?? []) {
      const customer = c.customer
      if (!customer || !customerStates.includes(customer.state)) continue

      for (const m of customer.managers) {
        if (!managerKinds.includes(m.kind)) continue
        const managerEmail = m.contacts.find((c) => c.kind === ContactKind.Email)?.value?.toLowerCase()
        if (!managerEmail) continue
        managerMap[managerEmail] = m
      }
    }

    const result = Object.values(managerMap) as ManagerModel[]
    result.sort((a, b) => (a?.displayName ?? '').localeCompare(b?.displayName ?? ''))

    return result
  }, [allCustomers.currentData])

  return managers
}
